// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"62b84d39","387":"7aadf2b4","488":"e7fe14a9","525":"711be232","787":"b0c08ad1","985":"a5162ef4"}[chunkId] + ".chunk.js";
};